module.exports = __webpack_public_path__ + "static/media/kwitantie.3fa36902.jpg";